import { useFormikContext } from 'formik';
import { useCurrentCompanyCurrencySign } from 'hooks/company/useCompanyCurrencySign';
import React from 'react';

import { Box, FormControl, FormGroup, Grid, Slider } from '@mui/material';

import useStyles from './styles';

interface ValueType {
  name?: string;
}
interface RateSelectorProps {
  minValue?: ValueType;
  maxValue?: ValueType;
}

const getLabelText = (value: number, currency: string) => `${value}${currency}`;
const MARKS = [0, 300];
const getLabelMarks = (currency: string) => {
  return MARKS.map((value) => ({
    label: getLabelText(value, currency),
    value,
  }));
};

const RateSelector = (props: RateSelectorProps) => {
  const { minValue, maxValue } = props;
  const classes = useStyles(props);
  const currency = useCurrentCompanyCurrencySign();
  const minName = minValue?.name || 'min';
  const maxName = maxValue?.name || 'max';

  const { values, setValues } = useFormikContext<any>();
  const onChange = (
    event: Event | React.SyntheticEvent<Element, Event>,
    rate: number | number[],
  ) => {
    if (Array.isArray(rate)) {
      setValues({ ...values, [minName]: rate?.[0], [maxName]: rate?.[1] });
    }
  };
  const defaultValue = [
    values?.[minName] || 0,
    values?.[maxName] || 300,
  ] as number[];

  const marksItems = getLabelMarks(currency);

  return (
    <FormControl fullWidth component="fieldset">
      <FormGroup>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid className={classes.container} item>
            <Box>
              <Slider
                min={MARKS[0]}
                max={MARKS[1]}
                color="secondary"
                marks={marksItems}
                valueLabelDisplay="auto"
                getAriaValueText={(value) => getLabelText(value, currency)}
                defaultValue={defaultValue}
                classes={{
                  valueLabel: classes.valueLabel,
                  mark: classes.mark,
                }}
                onChangeCommitted={onChange}
              />
            </Box>
          </Grid>
        </Grid>
      </FormGroup>
    </FormControl>
  );
};

export default RateSelector;
